export default __webpack_public_path__ + "static/media/ram.ec20c81f.svg";